export const CONSTANTS = {
  yourProjects: 'Your Projects',
  createProject: 'Create project',
  welcome: 'Welcome ',
  welcome_text_partial: 'to the My Cloud Security User Self Service',
  welcome_text: 'Welcome to the My Cloud Security User Self Service',
  noPermissionText:
    'The project management is allowed only for the Technical Responsible or the Service Owner of a cloud account.',
  appDownText:
    'The User Self Service Portal is currently Unavailable.Apologies for the inconvenience.',
  wizDashboard: 'Wiz Dashboard',
  cnappWiki: 'CNAPP Wiki',
  vivaEngage: 'Viva Engage',
  editProject: 'Edit Project',
  confirmAccessReview: 'Confirm Access Review',
  deleteProject: 'Delete Project',
  project: 'Project',
  owners: 'Owners',
  members: 'Members',
  subscriptions: 'Subscriptions',
  kubernetesCluster: 'Kubernetes Clusters',
  projectName: 'Project Name',
  projectId: 'Project Id',
  parentProjectId: 'Parent Project Id',
  description: 'Description',
  lastAccessReview: 'Last Access Review',
  lastAccessReviewBy: 'Last Access Review By',
  currentMembers: 'Current Members',
  noMembersAssigned: 'No members assigned to the project',
  assignUser: 'Assign a User',
  addUser: 'Add a User',
  invalidEmail: 'Invalid email',
  addUserToProject: 'Add User To Project',
  assignEntraGroup: 'Assigned Entra ID Groups',
  addEntraGroup: 'Add an Entra ID Group',
  entraGroupObjectId: 'Entra ID Group Object ID',
  invalidEntraGroupId: 'Invalid Entra Group Object ID',
  addEntraGroupToProject: 'Add Entra ID Group to Project',
  noSubscriptionsAvailable: 'No subscriptions available to your user.',
  noClustersAvailable: 'No clusters available to your user.',
  projectDescription: 'Project Description',
  businessUnit: 'Business Unit',
  projectOwners: 'Project Owners',
  addProjectOwner: 'Add a Project Owner',
  add: 'Add',
  setAsFolder: 'Set As Folder',
  setToFolder: 'Set To Folder',
  save: 'Save',
  cancel: 'Cancel',
  mcsAutomation: 'MCS-Automation',
};

export const NOTIFICATIONS = {
  warning: 'warning',
  danger: 'danger',
  success: 'success',
  info: 'info',
  error: 'Error',
  fetchProjectDataError: 'Unable to Fetch Project Data from Wiz.',
  fetchUsersError: 'Unable to get Users.',
  unableToCreateProject: 'Unable to create project.',
  unableToUpdateProject: 'Unable to update project.',
  canBeDeleted: 'Do you want to delete ',
  delete: 'Delete',
  successCap: 'Success',
  removedFrom: ' Removed from ',
  alreadyAMember: 'Already a Member',
  isAlreadyAMember: ' is already a member.',
  alreadyAGroup: 'Already a Group',
  isAlreadyAGroup: ' group is already assigned.',
  accessReviewUpdate: ' Access Review Updated for ',
  addedTo: ' Added to ',
  noSubscriptions: 'No Subscriptions Selected',
  noSubscriptionOrClusters: 'No Subscriptions/Clusters Selected',
  selectOneSubscription: 'Please Select at least one Subscription.',
  selectSubscriptionOrCluster:
    'Please Select at least one subscription or cluster.',
  actionUndone: 'This action cannot be undone.',
  projectDeleted: 'Project deleted successfully.',
  duplicateOwner: 'Duplicate Owner',
  userAlreadyExists: 'User already in list of owners.',
  invalidEmail: 'Invalid Email Format',
  invalidInput: 'Invalid Input',
  inputNotValid: 'Input not in a valid format.',
  projectCannotBeEdited: 'Project Cannot Be Edited',
  projectCreatedSuccess: 'Project created successfully',
  failedToLoad: 'Failed to load valid project data after 3 attempts.',
  cantEditPersonalProject: "You can't edit a Personal Project.",
  unableToRemoveOwners: 'Unable to Remove Project Owner',
  cantRemove: "You can't remove yourself.",
  userNotFound: 'User Not Found',
  unableToFindUser: 'Unable to find User on Wiz.',
  project: 'Project ',
  created: ' created.',
  updated: ' updated.',
  dot: '.',
  colon: ': ',
  qMark: '?',
};